/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Col, Input, message, Modal, Row, Form, Button } from 'antd'
import { FormComponentProps } from 'antd/es/form'
import TextArea from 'antd/lib/input/TextArea'
import { createCompanySetting, getAllCompanySetting, updateCompanySetting } from '../../../authorization-module/user-role/duck/service'
import { CompanyAuth } from '../../../authorization-module/people/model'

interface Param {
    closeModal: Function
    isEdit?: boolean
    dataEdit?: any
}

type Props = FormComponentProps & Param
const { confirm } = Modal
const CompanyForm: React.FC<Props> = (props: Props) => {
    const { getFieldDecorator, resetFields, validateFields } = props.form
    const [dataEdit, setDataEdit] = useState<CompanyAuth>()
    const [dataCompanyName, setDataCompanyName] = useState<string[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        getAllCompanySetting().then((data) => {
            if (data) {
                const companyName = data.map((it) => { return it.companyName.toLowerCase() })
                setDataCompanyName(companyName)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (props.dataEdit) {
            setDataEdit(props.dataEdit)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.dataEdit])

    useEffect(() => {
        if (props.closeModal) {
            resetFields()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.closeModal])

    const updateCompany = () => {
        validateFields(['companyNameEdit', 'addressEdit'], (err, values) => {
            if (!err) {
                setIsLoading(true)
                const updateBody: CompanyAuth = {
                    companyName: values.companyNameEdit.replace(/ +/g, ' ').trim(),
                    companyAddress: values.addressEdit.trim() || '',
                    active: true
                }
                updateCompanySetting(dataEdit?.id!!, updateBody).then((res) => {
                    props.closeModal(res)
                    message.success('The Update has finished successfully.')
                    setIsLoading(false)
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    props.closeModal()
                })
            }
        })
    }

    const addNewCompany = () => {
        validateFields(['companyName', 'address'], (err, values) => {
            if (!err) {
                setIsLoading(true)
                const tempBody: CompanyAuth = {
                    companyName: values.companyName.replace(/ +/g, ' ').trim(),
                    companyAddress: values.address?.trim() || '',
                    active: true
                }
                createCompanySetting(tempBody).then((res) => {
                    message.success('You have Successfully save the data.')
                    props.closeModal(res)
                    setIsLoading(false)
                    setDataCompanyName([...dataCompanyName, res.companyName])
                }).catch((err) => {
                    console.log(err)
                    setIsLoading(false)
                })
                resetFields(['companyName', 'address'])
            }
        })
    }

    const closeModalConfirm = () => {
        confirm({
            title: 'Are you sure ?',
            content: 'You want to leave this page ?',
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                props.closeModal()
            },
            onCancel() {
                console.log('Cancel')
            }
        })
    }

    const validateCompany = (_: any, value: any, callback) => {
        if (value) {
            const CheckValue = value.replace(/ +/g, ' ').trim()
            const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
            const pattern = /[A-Za-z0-9ก-๙]+/
            const isDataDuplicate = dataCompanyName.includes(CheckValue.toLowerCase().trim())
            const defaultCompanyName = dataEdit?.companyName
            if (pattern.test(CheckValue) && !isDataDuplicate && !format.test(CheckValue.charAt(0))) {
                callback()
            } else {
                if (format.test(CheckValue.charAt(0))) {
                    callback('Enter more than 1 letter and can not contain any of the following characters ' + format)
                } else if (value.trim() === defaultCompanyName) {
                    callback()
                } else if (isDataDuplicate) {
                    callback('The Company Name is already exists. It must be unique. Please try another one.')
                } else {
                    callback('Default value is not a valid')
                }
            }
        } else {
            callback()
        }
    }

    return (
        <>
            {props.isEdit
                ? <Form>
                    <Row>
                        <Col span={24}>
                            <Form.Item label='Company Name'>
                                {getFieldDecorator('companyNameEdit', {
                                    initialValue: dataEdit?.companyName,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Company Name is required'
                                        },
                                        {
                                            validator: validateCompany
                                        }
                                    ]
                                })(
                                    <Input
                                        placeholder="Company Name"
                                        maxLength={50}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item label='Address'>
                                {getFieldDecorator('addressEdit', {
                                    initialValue: dataEdit?.companyAddress
                                })(
                                    <TextArea placeholder='Address'
                                        autoSize={{minRows: 2, maxRows: 3}}
                                        maxLength={255}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Form.Item style={{ textAlign: 'center', paddingBottom: '4%', marginTop: 10}}>
                            <Button type="primary" htmlType="button" style={{ float: 'right' }} loading={isLoading} onClick={() => updateCompany()}>
                        Submit
                            </Button>
                            <Button type="default" htmlType="button" style={{ float: 'right', marginRight: 10 }} onClick={() => closeModalConfirm()}>
                        Cancel
                            </Button>
                        </Form.Item>
                    </Row>
                </Form>
                : <Form>
                    <Row>
                        <Col span={24}>
                            <Form.Item label='Company Name'>
                                {getFieldDecorator('companyName', {
                                    initialValue: dataEdit?.companyName,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Company Name is required'
                                        },
                                        {
                                            validator: validateCompany
                                        }
                                    ]
                                })(
                                    <Input
                                        placeholder="Company Name"
                                        maxLength={50}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item label='Address'>
                                {getFieldDecorator('address', {
                                    initialValue: dataEdit?.companyAddress,
                                    rules: [
                                        {
                                            validator: validateCompany
                                        }
                                    ]
                                })(
                                    <TextArea placeholder='Address'
                                        autoSize={{minRows: 2, maxRows: 3}}
                                        maxLength={255}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Form.Item style={{ textAlign: 'center', paddingBottom: '4%', marginTop: 10}}>
                            <Button type="primary" htmlType="button" style={{ float: 'right', marginRight: 10 }} loading={isLoading} onClick={addNewCompany}>
                                Add
                            </Button>
                        </Form.Item>
                    </Row>
                </Form>}
        </>

    )
}

const CompanyFormModal = Form.create<Props>()(CompanyForm)
export default CompanyFormModal
